import Styles from './CustomizeSchedule.module.scss'
import { Heading, HeadingLevel } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import { ArrowCurveRightDown } from 'blaze-ui/icons'
import { ScheduleCard } from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/ScheduleCard'
import { useId } from '@react-aria/utils'
import { DaysBeforeReviewRadioGroup } from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/DaysBeforeReviewRadioGroup'

dayjs.extend(advancedFormat)

interface Props {
  daysBeforeReview: number
  onDaysBeforeReviewChange: (daysBeforeReview: number) => void
  startDate: string
  headingLevel?: HeadingLevel
  chipSize?: 'lg' | 'xs' | 'sm' | 'md'
  chipClassName?: string
}

export const DaysBeforeReviewInput = ({
  daysBeforeReview,
  onDaysBeforeReviewChange,
  startDate,
  headingLevel = 3,
  chipSize = 'lg',
  chipClassName,
}: Props) => {
  const nameOfDay = dayjs(startDate).subtract(daysBeforeReview, 'day').format('dddd')
  const id = useId()

  return (
    <ScheduleCard>
      <div className={Styles.description}>
        <Heading level={headingLevel} id={id}>
          When do you want to review each new batch of content?
        </Heading>
        <Text variant="secondary" color="var(--dark-60)">
          Choose how many days before publishing you'd like to review your content.
        </Text>
      </div>
      <DaysBeforeReviewRadioGroup
        aria-labelledby={id}
        className={Styles.chipsInput}
        value={daysBeforeReview}
        onChange={onDaysBeforeReviewChange}
        chipSize={chipSize}
        chipClassName={chipClassName}
      />
      <div className={Styles.explainer}>
        <div>
          <ArrowCurveRightDown size={20} color="var(--selected-fill)" />
        </div>
        <Text variant="secondary" color="var(--dark-80)">
          New content will be ready every <b>{nameOfDay}</b>; we'll email you a reminder.
        </Text>
      </div>
    </ScheduleCard>
  )
}
